import { useRef } from "react";
import useMap from "./hook";
import Style from "./style";
import Sider from "./Sider";
import OverviewMapControllers from "../../../../components/dashboards/components/OverviewMap/Controllers";
import useLevels from "./useLevels";

export default function Map({ api, mod, activeFilters }) {
  const container = useRef();
  const { fetchLevel, getName } = useLevels();
  const {
    zoomHandler,
    activeMarker,
    moveUpHandler,
    zoomOutHandler,
    setActiveMarker,
    moveDownHandler,
  } = useMap({ container, activeFilters, mod, api });


  return (
    <Style>
      <div ref={container} className="map-c" />

      {activeMarker ? (
        <Sider
          mod={mod}
          fetchLevel={fetchLevel}
          getName={getName}
          activeMarker={activeMarker}
          setActiveMarker={setActiveMarker}
        />
      ) : null}

      <OverviewMapControllers
        documentationCollapsed
        zoomHandler={zoomHandler}
        moveUpHandler={moveUpHandler}
        zoomOutHandler={zoomOutHandler}
        moveDownHandler={moveDownHandler}
      />
    </Style>
  );
}
